<app-modal>
    <div class="modal-header"
         modal-header>
        <h5 class="modal-title">{{title}}</h5>
    </div>
    <div class="modal-body" modal-body>
        <app-revision-info [revisionInfo]="revisionInfo"></app-revision-info>
    </div>
    <div class="modal-footer" modal-footer>
        <app-button type="simple"
                (click)="onCancel()">{{"generic.buttons.close" | translate}}
        </app-button>
    </div>
</app-modal>
